import { SelectProps } from 'antd';
import { get } from 'lodash-es';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import DeliveryCompanySelect from './DeliveryCompanySelect';
import FieldWithLabel from './FieldWithLabel';
import { FieldProps } from './types';

type DeliveryCompanySelectFieldProps<TFieldValues extends FieldValues> =
  SelectProps &
    FieldProps & {
      control: Control<TFieldValues>;
      name: Path<TFieldValues>;
    };

export default function DeliveryCompanySelectField<
  TFieldValues extends FieldValues,
>({
  name,
  control,
  label,
  hideError,
  required,
  onChange,
  hideErrorMessage,
  ...props
}: DeliveryCompanySelectFieldProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState }) => {
        const error = get(formState.errors, name);
        const errorMessage =
          !hideError && typeof error?.message === 'string'
            ? error.message
            : undefined;
        const status = !hideError && errorMessage ? 'error' : '';

        return (
          <FieldWithLabel label={label} required={required}>
            <DeliveryCompanySelect
              status={status}
              {...field}
              {...props}
              onChange={(value, option) => {
                field.onChange(value);
                onChange && onChange(value, option);
              }}
            />
            {!hideErrorMessage && !hideError && errorMessage && (
              <p className={'text-xs text-red-500'}>{errorMessage}</p>
            )}
          </FieldWithLabel>
        );
      }}
    />
  );
}
